import styled from "styled-components";
import { TextField, Grid, InputLabel, Fab } from "@material-ui/core";

export const STTextField = styled(TextField)`
  && {
    display: none;
  }
`;

export const STGrid = styled(Grid)`
  && {
    margin-top: 15px;
  }
`;

export const STPreviewImage = styled.img`
  max-width: 150px;
  max-height: 50px;
  display: block;
`;

export const STFab = styled(Fab)`
  && {
    margin-left: 10px;
  }
`;

export const STButtonsGrid = styled(Grid)`
  && {
    width: fit-content;
  }
`;

export const STInputLabel = styled(InputLabel)`
  && {
    font-size: 13px;
    padding-bottom: 4px;
  }
`;
